import React from 'react'
import { Link } from "react-router-dom";

export default function Location() {
  return (
    <>
    <section className="ptb-40 bg-1" id="location">
        <div className="container">
          <h2>📍 Riya Dubey – Areas Served 📍</h2>
          <div className="rd-location-set">
            <Link to="/huda-city-center-escorts">📍 Huda City Center</Link>
            <Link to="/dlf-cyber-city-escorts">📍Dlf Cyber City</Link>
            <Link to="/mg-road-escorts">📍MG Road</Link>
            <Link to="/south-city-escorts">📍South City</Link>
            <Link to="/golf-course-escorts">📍Golf Course</Link>
            <Link to="/iffco-chowk-escorts">📍Iffco Chowk</Link>
            <Link to="/manesar-escorts">📍Manesar</Link>
            <Link to="/sohna-road-escorts">📍Sohna Road</Link>
            <Link to="/bijwasan-escorts">📍Bijwasan</Link>
            <Link to="/bristol-chowk-escorts">📍Bristol Chowk</Link>
            <Link to="/ardee-city-escorts">📍Ardee City</Link>
            <Link to="/vatika-city-escorts">📍Vatika City</Link>
            <Link to="/surajkund-escorts">📍Surajkund</Link>
            <Link to="/galleria-market-escorts">📍Galleria Market</Link>
            <Link to="/palam-vihar-escorts">📍Palam Vihar</Link>
            <Link to="/badshahpur-escorts">📍Badshahpur</Link>
            <Link to="/chakkarpur-escorts">📍Chakkarpur</Link>
            <Link to="/guru-dronacharya-escorts">📍Guru Dronacharya</Link>
            <Link to="/hans-enclave-escorts">📍Hans Enclave</Link>
            <Link to="/kendriya-vihar-escorts">📍Kendriya Vihar</Link>
            <Link to="/pataudi-chowk-escorts">📍Pataudi Chowk</Link>
            <Link to="/sushant-lok-escorts">📍Sushant Lok</Link>
            <Link to="/udyog-vihar-escorts">📍Udyog Vihar</Link>
            <Link to="/sikanderpur-escorts">📍Sikanderpur</Link>
            <Link to="/dlf-phase-1-escorts">📍Dlf Phase 1</Link>
            <Link to="/dlf-phase-2-escorts">📍Dlf Phase 2</Link>
            <Link to="/dlf-phase-3-escorts">📍Dlf Phase 3</Link>
            <Link to="/gurgaon-sector-1-escorts">📍Gurgaon Sector 1</Link>
            <Link to="/gurgaon-sector-14-escorts">📍Gurgaon Sector 14</Link>
            <Link to="/gurgaon-sector-15-escorts">📍Gurgaon Sector 15</Link>
            <Link to="/gurgaon-sector-16-escorts">📍Gurgaon Sector 16</Link>
            <Link to="/gurgaon-sector-27-escorts">📍Gurgaon Sector 27</Link>
            <Link to="/gurgaon-sector-28-escorts">📍Gurgaon Sector 28</Link>
            <Link to="/gurgaon-sector-29-escorts">📍Gurgaon Sector 29</Link>
            <Link to="/gurgaon-sector-45-escorts">📍Gurgaon Sector 45</Link>
        </div>
         </div>
    </section>
    </>
  )
}
